import { restClient } from '@/Core'
import type { Message } from '../Contracts'
import { mapApiMessage, type ApiMessage } from '../Helpers/apiMappers'

interface SearchResponse {
    items?: ApiMessage[]
    meta?: { hasMore?: boolean }
}

interface SearchChatMessagesParams {
    chatId: string
    query: string
    limit?: number
    offset?: number
}

/**
 * Server-side message search: case-insensitive substring match over the
 * message text with HTML markup ignored (the backend keeps a normalized
 * shadow column of every message). Deleted messages are excluded, newest
 * first. The panel shows the first page only — meta.hasMore is ignored
 * until a "show more" affordance exists.
 */
export const SearchChatMessagesTask = async ({
    chatId,
    query,
    limit = 50,
    offset = 0,
}: SearchChatMessagesParams): Promise<Message[]> => {
    const response = (await restClient.get(
        `/services/chat/chats/${chatId}/messages/search`,
        { searchParams: { q: query, limit, ...(offset ? { offset } : {}) } },
        { forceRefresh: true }
    )) as SearchResponse | null

    return (response?.items ?? []).map((item) => mapApiMessage(item, chatId))
}
